import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authService, portalService } from "../../../configs/constants";

const AuthTransfer = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as { sso?: string };

  const [isSuccess, setSuccess] = useState(false);
  const [isRedirecting, setRedirecting] = useState(false); // FIX 👍

  const containerStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    textAlign: "center",
    fontSize: "20px",
    color: "#333",
    flexDirection: "column",
    padding: "0 20px",
  };

  useEffect(() => {
    const checkCookieAvailability = (): boolean => {
      document.cookie = "testCookie=1; SameSite=Lax";
      if (document.cookie.includes("testCookie")) {
        document.cookie = "testCookie=; Max-Age=0";
        return true;
      }
      return false;
    };

    const checkIdToken = async () => {
      const response = await fetch(`${authService}/check-idtoken`, {
        method: "GET",
        credentials: "include",
      });

      if (!response.ok) {
        setSuccess(false);
        return setTimeout(() => navigate("/login"), 2000);
      }

      const resp = await response.json();

      if (resp.success) {
        setSuccess(true);
        setRedirecting(true); // 👈 Hide UI immediately

        const dataStr = resp.data ? resp.data.split("j:")[1] : null;
        const dataObj = JSON.parse(dataStr);
        const name = dataObj?.name || "User";

        localStorage.setItem("sso-user", JSON.stringify({ name }));

        const afterLoginRoute = sessionStorage.getItem("afterLoginRoute");
        sessionStorage.removeItem("afterLoginRoute");

        navigate(afterLoginRoute || "/ticketing");
      }
    };

    const checkAuth = async () => {
      if (checkCookieAvailability()) {
        if (props?.ssoRoot) await checkIdToken();
      } else {
        alert(
          "Cookies are disabled. Please enable cookies to use this application."
        );
      }
    };

    setTimeout(() => checkAuth(), 200);
  }, [navigate]);

  useEffect(() => {
    const sso = localStorage.getItem("sso-login");

    const initSSO = async () => {
      const res = await axios.post(`${portalService}/acl/my-permission`);
      if (res.status === 200) navigate("/");
      localStorage.removeItem("sso-login");
    };

    if (sso) {
      setTimeout(() => initSSO(), 100);
    }
  }, [navigate]);

  // FIX: Hide component UI instantly when redirecting
  if (isRedirecting) return null;

  return (
    <div style={containerStyle}>
      <>
        {state?.sso === "init" && (
          <span>Redirecting to Microsoft for authentication...</span>
        )}

        {props?.ssoRoot && isSuccess && (
          <span>
            You are successfully logged in <br />
            <br /> Redirecting to menu...
          </span>
        )}

        {state?.sso === "no_data" && (
          <span>
            You do not have the required permissions. Please ask the admin to
            provide access.
          </span>
        )}

        {!state?.sso && !isSuccess && (
          <span>
            You need to{" "}
            <a onClick={() => navigate("/login")}>
              <u>login</u>
            </a>
          </span>
        )}
      </>
    </div>
  );
};

export default AuthTransfer;
